<script>
import Vue from 'vue'
import { isMobile } from '../../deviceDetect/index'
import { mapGetters } from 'vuex'
import { vAvatar as Avatar } from '@amaury-tobias/v-avatar'
import fullscreen from 'vue-fullscreen'
import ModalScan from '@/components/utility/modal-wizard/components/modal-scan.vue'

Vue.use(fullscreen)

export default {
  name: 'site-header',
  components: { ModalScan, Avatar },
  data () {
    return {
      activeModalScan: false,
      fullscreen: false,
      isImageError: false,
      isMobile,
      isMenuOpen: false,
    }
  },
  methods: {
    async changeBusinessAccount (businessId) {
      try {
        console.log('Switching to business ID:', businessId)
        NProgress.start()
        this.$store.dispatch('changeBusinessAccount', businessId)
            .then((response) => {
                  if (response && response.data && response.data._status) {
                    window.location.reload()
                  }
                }
            )
      } catch (error) {
        console.error('Failed to switch business:', error)
      }
    },
    selectBusiness(business) {
      if (!business || business.isCurrent){
        return ;
      }
      this.changeBusinessAccount(business.vendorId);
    },
    openModalScan () {
      this.activeModalScan = true
      $('body').addClass('modal-open')
    },
    closeModalScan () {
      console.log('CLOSE2')

      this.activeModalScan = false
      $('body').removeClass('modal-open')
    },
    goToHome () {
      this.$router.push('/').catch(() => {})
    },
    toggleSideBarFirst: function () {
      let body = document.querySelector('body')
      let first = document.querySelector('.site-header .sidebar-toggle-first')
      body.classList.toggle('site-sidebar-opened')
      return false
    },
    toggleSideBarSecond: function () {
      let body = document.querySelector('body')
      //let second =  document.querySelector('.site-header .sidebar-toggle-second');
      body.classList.toggle('compact-sidebar')
      return false
    },
    removeInStorageSavedTabs () {
      if (!_.isEmpty(this.$route.params.estimate_id)) {
        this.$storage.remove('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView')
      } else if (!_.isEmpty(this.$route.params.card_id)) {
        this.$storage.remove('views.cardsEdit.' + this.$route.params.card_id + '.defaultView')
      } else if (!_.isEmpty(this.$route.params.invoice_id)) {
        if (this.$route.path.includes('/excess')) {
          this.$storage.remove('views.invoiceExcess.' + this.$route.params.invoice_id + '.defaultView')
        } else {
          this.$storage.remove('views.invoiceView.' + this.$route.params.invoice_id + '.defaultView')
        }
      }
    },
    logout: function () {
      this.$store.dispatch('logout')
          .then(() => {
            this.removeInStorageSavedTabs()
            document.body.style.zoom = null
            this.$router.push('/')
          })
    },
    onImageError () {
      this.isImageError = true
    },
    toggleFullscreen () {
      let body = document.querySelector('body')
      //console.log('Click1');
      this.$fullscreen.toggle(body, {
        wrap: false,
        callback: this.fullscreenChange
      })
    },
    fullscreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    setCompactSidebar: function () {
      this.$nextTick(() => {
        document.body.classList.add('compact-sidebar')
      })
    },
  },
  computed: {
    ...mapGetters({
      isTechnicalUser: 'isTechnicalUser',
      isCustomerUser: 'isCustomerUser',
      isEstimatorUser: 'isEstimatorUser',
      isPDRTechnicianUser: 'isPDRTechnicianUser',
      isShopManagerUser: 'isShopManagerUser',
      getBusinessName: 'getBusinessName',
      vendorInfo: 'vendorInfo',
      isUserMultiSite: 'isUserMultiSite',
      multiSites: 'getMultiSites',
    }),
    count: function () {
      return this.$store.state.count
    },
    userInfo: function () {
      return this.$store.state.userInfo
    },
    profile_picture_url: function () {
      return this.$store.getters.avatar
      //return appConfig.baseAPIURL + '/img/avatars/' + this.userInfo.profile_picture;
    },
    avatarStyle () {
      return {
        'font': `16px / 40px 'Nunito Sans', sans-serif`,
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.closeDropdown);
    window.addEventListener('orientationchange', (event) => {
      if (isMobile) {
        this.setCompactSidebar()
      }
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
  },
}
</script>

<template>
  <div>

    <!-- Preloader -->
    <div class="preloader" style="display: none"></div>
    <!-- Header -->
    <div class="site-header" :class="{ 'hide-menu': isMobile }">
      <nav class="navbar navbar-light">
        <div class="navbar-left center-middle">
          <a @click="goToHome" href="/" class="navbar-brand-logo-svg-header"></a>
          <div @click="toggleSideBarFirst" class="toggle-button light sidebar-toggle-first float-xs-left hidden-md-up">
            <span class="hamburger"></span>
          </div>
          <div v-if="isMobile && ($route.path.includes('/files') || $route.path == '/')" class="scan-mobile"
               @click="openModalScan">
            <i class='bx bx-scan'></i>
          </div>
          <div v-if="isMobile && ($route.path.includes('/estimates/view') || $route.path.includes('/files/view'))"
               class="camera-mobile" @click="$store.commit('cameraCountIncrease')">
            <i class='bx bxs-camera'></i>
          </div>
        </div>
        <div class="navbar-right navbar-toggleable-sm collapse" id="collapse-1">
          <div @click="toggleSideBarSecond"
               class="toggle-button light sidebar-toggle-second float-xs-left hidden-sm-down">
            <span class="hamburger"></span>
          </div>

          <div v-if="isMobile && ($route.path.includes('/files') || $route.path == '/')" class="scan-mobile scan-tablet"
               @click="openModalScan">
            <i class='bx bx-scan'></i>
          </div>
          <ul class="nav navbar-nav float-md-right d-flex items-center">
            <li class="nav-item hidden-sm-down">
              <span class="nav-link active full-name">{{ userInfo.first_name }} {{ userInfo.last_name }}</span>
            </li>
            <li class="nav-item dropdown hidden-sm-down">
              <a href="#" data-toggle="dropdown" aria-expanded="false"
                 class="d-flex items-center justify-content-center">
                                <span class="avatar">
                                    <img  :src="profile_picture_url" @error="onImageError"
                                         class="hidden-xs-up hidden-sm-down">
                                    <avatar
                                        :username="`${userInfo.first_name} ${userInfo.last_name}`"
                                        :src="!isImageError ? profile_picture_url : ''"
                                        :size="40"
                                        rounded
                                        :customStyle="avatarStyle"
                                    />
                                </span>
              </a>
              <div class="dropdown-menu dropdown-menu-right animated fadeInUp">
                                <span style="cursor: pointer;" class="dropdown-item"
                                      @click="$router.push({name: 'myAccount', params: {tab:'my-account', customTab: 'my-account', customSubTab: ''}}).catch(()=>{})">
                                  <i class="ti-user mr-0-5"></i>My Account
                                </span>
                <span v-if="isShopManagerUser"
                      @click="$router.push({name: 'business', params: {customTab: 'business-profile', customSubTab: 'details'}}).catch(()=>{})"
                      style="cursor: pointer;" class="dropdown-item">
                                  <i class="ti-briefcase mr-0-5"></i>Business
                                </span>

                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item" @click="logout"><i class="ti-power-off mr-0-5"></i> Sign out</a>
              </div>
            </li>
          </ul>
          <ul class="nav navbar-nav">
            <li class="nav-item hidden-sm-down">
              <a @click.prevent="toggleFullscreen" class="nav-link toggle-fullscreen clickable">
                <i class="ti-fullscreen"></i>
              </a>
            </li>
          </ul>
          <template v-if="isUserMultiSite">
          <b-dropdown
              v-if="!isMobile"
              id="business-selector"
              ref="businessMenu"
              class="site-header__business-name dropdown-options"
              no-caret
              @show="isMenuOpen = true"
              @hide="isMenuOpen = false">
            <template v-slot:button-content>
              {{ getBusinessName }}
              <span class="dropdown-arrow" :class="{ 'is-active': isMenuOpen }">
                <i class='bx bx-down-arrow'></i>
              </span>
            </template>
            <b-dropdown-item
                v-for="business in multiSites"
                :key="business.vendorId"
                :active="business.isCurrent"
                :class="{active:business.isCurrent}"
                @click="selectBusiness(business)"
                class="multisite-option-item">
              {{ business.displayName }}
            </b-dropdown-item>
          </b-dropdown>
          </template>
        </div>
      </nav>
    </div>
    <modal-scan v-if="activeModalScan" @closeModalScan="closeModalScan"></modal-scan>
    <audio id="scannerAudio" src="../../../src/assets/audio/scanner-beep.mp3"></audio>
  </div>
</template>

<style scoped>
.V3 .site-header .dropdown-options {
  height: 39px;
  width: 149px;
  margin-right: 15px;
}

.V3 .site-header .dropdown-options >>> .btn {
  box-sizing: border-box;
  border: 1px solid #d9dee8;
  border-radius: 3px;
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
  width: 149px;
  text-align: left;
  background-color: #FFFFFF;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  box-shadow: none;
}

.V3 .site-header .dropdown-options >>> .btn:hover,
.V3 .site-header .dropdown-options >>> .btn:focus,
.V3 .site-header .dropdown-options >>> .btn:active {
  outline: none !important;
  box-shadow: none !important;
  border-color: #d9dee8 !important;
  background-color: #FFFFFF !important;
  color: #1C1F39 !important;
}

.V3 .site-header .site-header__business-name {
  display: inline-block;
  vertical-align: middle;
  margin-left: 50px;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #1C1F39;
  position: relative;
}

.V3 .site-header .site-header__business-name >>> .dropdown-menu {
  border: 1px solid #ddd !important;
  box-shadow: none !important;
  width: max-content !important;
  max-width: none !important;
  border-radius: 3px;
  background-color: #fff;
  min-width: 260px !important;
  left: 0 !important;
  right: auto !important;
  text-align: left;
  list-style: none;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  z-index: 9999;
  top: 100% !important;
  margin-top: 0 !important;
}

.V3 .site-header .site-header__business-name >>> .dropdown-menu .dropdown-item {
  padding: .5rem 1.5rem;
  width: max-content !important;
  min-width: 100%;
  clear: both;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  display: block;
  white-space: nowrap !important;
}

.V3 .site-header .site-header__business-name >>> .dropdown-menu .multisite-option-item:not(.active) .dropdown-item:hover,
.V3 .site-header .site-header__business-name >>> .dropdown-menu .multisite-option-item:not(.active):hover .dropdown-item {
  background-color: #f0f4ff !important;
  color: #2563eb !important;
  font-weight: 600;
}

.V3 .site-header .site-header__business-name >>> .dropdown-menu .dropdown-item:hover {
  background-color: #f0f4ff;
  color: #2563eb;
  font-weight: 600;
}

.V3 .site-header .site-header__business-name >>> .dropdown-menu.show {
  display: block;
  top: 100% !important;
  left: 0 !important;
  right: auto !important;
  margin-top: 0 !important;
  transform: none !important;
}

.V3 .site-header .site-header__business-name.dropdown-options:hover >>> .dropdown-menu:not(.show) {
  display: none !important;
}

.V3 .site-header .site-header__business-name.dropdown-options >>> .btn {
  border: 0;
  width: fit-content;
  min-width: auto;
  display: inline-flex;
  align-items: center;
  padding-right: 0 !important;
}

.V3 .site-header .site-header__business-name.dropdown-options >>> .btn:active {
  background-color: transparent !important;
  color: #1C1F39 !important;
  box-shadow: none !important;
}

.V3 .site-header .site-header__business-name.dropdown-options >>> .btn:hover {
  outline: 0 !important;
  background-color: transparent !important;
  color: #1C1F39 !important;
  box-shadow: none !important;
}

.V3 .site-header .site-header__business-name.dropdown-options >>> .btn:focus,
.V3 .site-header .site-header__business-name.dropdown-options.show >>> .btn,
.V3 .site-header .site-header__business-name.dropdown-options >>> .show > .btn,
.V3 .site-header .site-header__business-name.dropdown-options >>> .btn.dropdown-toggle[aria-expanded="true"] {
  background-color: transparent !important;
  color: #1C1F39 !important;
  border-color: transparent !important;
  outline: none !important;
  box-shadow: none !important;
}

.V3 .site-header .site-header__business-name >>> .dropdown-menu .multisite-option-item.active .dropdown-item {
  cursor: default !important;
  pointer-events: none;
}

.dropdown-arrow {
  display: inline-block;
  margin-left: 4px;
  width: 12px;
  text-align: center;
  flex: 0 0 12px;
  line-height: 1;
  transition: transform ease;
}

.dropdown-arrow.is-active {
  transform: rotate(180deg);
  bottom: 3px;
}
</style>
<style>
.scan-mobile {
  position: absolute;
  right: 70px;
  top: 15px;
  z-index: 10001;
}

.scan-tablet {
  position: absolute;
  left: 100px;
  top: 13px;
  z-index: 10001;
}

.camera-mobile {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 10001;
}
.camera-mobile .bxs-camera,
.scan-mobile .bx-scan {
  font-size: 34px;
  color: #1d4898;
  cursor: pointer;
}

.navbar-light .navbar-brand {
  color: #212330 !important;
}

.site-header__business-name {
  font-size: 14px;
  font-weight: 600;
  color: #1C1F39;
  margin: 0 12px;
  align-self: center;
  white-space: nowrap;
}

/* Mobile: hide or adjust */
@media (max-width: 767px) {
  .site-header__business-name {
    display: none;
  }
}

.center-middle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hide-menu .navbar-left.center-middle .toggle-button.light.sidebar-toggle-first.float-xs-left.hidden-md-up {
  position: absolute;
  left: 0;
  display: block !important;
  float: left !important;
}

/* =================================================================
Header
================================================================= */

.V3 .fixed-header .site-header {
  position: fixed;
  top: 0;
  left: 220px;
  right: 0;
  z-index: 10000;
}

.V3 .fixed-header .site-header.hide-menu .navbar-brand-logo-svg-header {
  background-image: url(../../assets/logos/logo2x.png);
  background-size: 100% auto;
  display: block;
  width: 120px;
  height: 24.31px;
  background-repeat: no-repeat;
}

.V3 .V3.fixed-header.site-sidebar-opened .site-header.hide-menu .navbar-brand-logo-svg-header {
  display: none;
}

.V3 .fixed-header.compact-sidebar .site-header {
  left: 70px;
}

.V3 .fixed-header .site-header.hide-menu {
  left: 0;
}

.V3 .site-header .navbar {
  padding: 0;
  background-color: #FFFFFF;
}

.V3 .site-header .navbar-left {
  background-color: #212330;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.V3 .site-header:not(.hide-menu) .navbar-left {
  float: left;
  width: 220px;
  display: none;
}

.V3 .compact-sidebar .site-header:not(.hide-menu) .navbar-left {
  width: 70px;
  display: none;
}

.V3 .site-header.hide-menu .navbar-left {
  background-color: #fff !important;
  height: 60px;
}

.V3 .site-header .navbar-brand {
  display: inline-block;
  float: none;
  margin: 0;
  padding: 1.3rem 0 0;
  height: 60px;
}

.V3 .site-header .navbar-brand .logo {
  width: 100px;
  height: 25px;
}

.V3 .compact-sidebar .site-header:not(.hide-menu) .navbar-brand .logo {
  width: 25px;
}

.V3 .site-header .navbar-right {
  padding: 0 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
}

.V3 .site-header:not(.hide-menu) .navbar-right {
  margin-left: 0px;
  height: 60px !important;
}

.V3 .compact-sidebar .site-header:not(.hide-menu) .navbar-right {
  margin-left: 0px;
}

.V3 .site-header .toggle-button {
  position: relative;
  width: 55px;
  height: 60px;
  line-height: 60px;
  font-size: 1.5rem;
  cursor: pointer;
}

.V3 .site-header .navbar-right .toggle-button {
  margin-left: -15px;
}

.V3 .site-header .toggle-button.light {
  color: rgba(0, 0, 0, 0.5);
}

.V3 .site-header .toggle-button.dark {
  color: rgba(255, 255, 255, 0.5);
}

.V3 .site-header .toggle-button span {
  position: absolute;
  display: block;
  top: 50%;
  right: 0;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.V3 .site-header .toggle-button span.hamburger {
  left: 15px;
  margin-top: -1px;
  width: 23px;
  height: 3px;
  border-radius: 2px;
}

.V3 .site-header .toggle-button span.more {
  left: 50%;
  margin: -2px 0 0 -2px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
}

.V3 .site-header .toggle-button.light span {
  background-color: #1B1E38;
}

.V3 .site-header .toggle-button.dark span {
  background-color: rgba(255, 255, 255, 0.5);
}

.V3 .site-header .toggle-button span:before,
.V3 .site-header .toggle-button span:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.V3 .site-header .toggle-button span.hamburger:before,
.V3 .site-header .toggle-button span.hamburger:after {
  height: 3px;
  border-radius: 2px;
}

.V3 .site-header .toggle-button span.more:before,
.V3 .site-header .toggle-button span.more:after {
  height: 4px;
  border-radius: 50%;
}

.V3 .site-header .toggle-button.light span:before,
.V3 .site-header .toggle-button.light span:after {
  background-color: #1B1E38;
}

.V3 .site-header .toggle-button.dark span:before,
.V3 .site-header .toggle-button.dark span:after {
  background-color: rgba(255, 255, 255, 0.5);
}

.V3 .site-header .toggle-button span.hamburger:before {
  top: -6px;
  width: 50%;
}

.V3 .site-header .toggle-button span.hamburger:after {
  bottom: -6px;
  width: 50%;
  margin-left: 50%;
}

.V3 .site-header .toggle-button span.more:before {
  top: -8px;
}

.V3 .site-header .toggle-button span.more:after {
  bottom: -8px;
}

.V3 .site-header .toggle-button.light:hover span,
.V3 .site-header .toggle-button.light:hover span:before,
.V3 .site-header .toggle-button.light:hover span:after,
.V3 .site-header .toggle-button.light:focus span,
.V3 .site-header .toggle-button.light:focus span:before,
.V3 .site-header .toggle-button.light:focus span:after {
  background-color: #333333;
}

.V3 .site-header .toggle-button.dark:hover span,
.V3 .site-header .toggle-button.dark:hover span:before,
.V3 .site-header .toggle-button.dark:hover span:after,
.V3 .site-header .toggle-button.dark:focus span,
.V3 .site-header .toggle-button.dark:focus span:before,
.V3 .site-header .toggle-button.dark:focus span:after {
  background-color: #FFFFFF;
}

.V3 .site-header .toggle-button-second {
  width: 45px;
  height: 59px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
}

.V3 .site-header .navbar-right .toggle-button-second {
  margin: 0 -15px 0 15px;
}

.V3 .site-header .toggle-button-second.light {
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.5);
}

.V3 .site-header .toggle-button-second.dark {
  border-left: 1px solid rgba(255, 255, 255, 0.125);
  color: rgba(255, 255, 255, 0.7);
}

.V3 .site-header .toggle-button-second i {
  display: inline-block;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.V3 .site-header .toggle-button-second.active i {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.V3 .site-header .navbar-nav > li > a,
.V3 .site-header .navbar-nav > li > span {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.V3 .site-header:not(.hide-menu) .navbar-nav > li > a,
.V3 .site-header:not(.hide-menu) .navbar-nav > li > span {
  padding-top: 0;
  padding-bottom: 0;
  line-height: 60px;
}

.V3 .site-header .navbar-nav > li > a i {
  position: relative;
  top: 2px;
  font-size: 1.3rem;
}

.V3 .site-header .navbar-nav > li .btn {
  vertical-align: baseline;
}

.V3 .site-header .navbar-nav > li .avatar img {
  vertical-align: top;
}

.V3 .site-header .navbar .dropdown-menu {
  margin-top: -1px;
  border-radius: 3px;
}

.V3 .site-header.hide-menu .navbar .navbar-toggleable-sm {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  padding: 1rem 2rem;
  background-color: #FFFFFF;
  border-bottom: 1px solid #DDDDDD;
  display: none !important;
}

@media (max-width: 991px) {
  .V3 .site-header .navbar {
    margin-left: 0 !important;
  }
}

.V3 .site-header .header-form {
  padding-top: 1.1rem;
}

.V3 .site-header.hide-menu .header-form {
  padding: 0.75rem 0;
}

/* .dropdown-menu-mobile {
       position: absolute !important;
       left: -80px !important;
       top: 55% !important;
 } */

.V3 .site-header .header-form form {
  position: relative;
}

.V3 .site-header .header-form .btn {
  position: absolute;
  top: 1px;
  right: 1px;
  color: #999999;
}

.V3 .site-header:not(.hide-menu) .header-form .form-control {
  width: 180px;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.V3 .site-header:not(.hide-menu) .header-form .form-control:focus {
  width: 300px;
}

/* .V3 .site-header .right-user-block-mobile {
       justify-content: flex-end;
       margin-right: 15px;
} */

.V3 .site-header .dropdown-more {
  display: block;
  padding: 0.75rem 1rem;
  background-color: #EEEEEE;
  color: #999999;
  text-align: center;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.V3 .site-header .dropdown-more:hover,
.V3 .site-header .dropdown-more:focus {
  color: #333333;
}

.V3 .site-header .full-name {
  color: #1B1E38;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
}
</style>



